const nestedCall = (
    context: any,
    component: any,
    methodName: string,
    isExist: Function,
    call: Function,
    nested = false,
    ...arg: any[]
) => {
    if (isExist(component, methodName)) {
        return call(context, component, methodName, ...arg)
    }
    if (component.extends) {
        const result = nestedCall(context, component.extends, methodName, isExist, call, true, ...arg)
        if (!(result instanceof Error)) return result
    }
    if (component.mixins?.length) {
        for (let i = component.mixins.length - 1; i >= 0; i--) {
            const result = nestedCall(context, component.mixins[i], methodName, isExist, call, true, ...arg)
            if (!(result instanceof Error)) return result
        }
    }
    const error = Error(`${methodName}() is not found in ${component.name}`)
    if (nested) return error
    throw error
}

const isMethodExist = (component: any, methodName: string) => typeof component.methods[methodName] === 'function'
const callMethod = (context: any, component: any, methodName: string, ...arg: any[]) =>
    component.methods[methodName].call(context, ...arg)

// TODO [P4] Need refactoring and remove this
export const callComponentMethod = (context: any, component: any, methodName: string, ...arg: any[]) =>
    nestedCall(context, component, methodName, isMethodExist, callMethod, false, ...arg)

const isComputedExist = (component: any, methodName: string) =>
    typeof component.computed[methodName]?.get === 'function'
const callComputed = (context: any, component: any, methodName: string) =>
    component.computed[methodName].get.call(context)

// TODO [P4] Need refactoring and remove this
export const callComponentComputed = (context: any, component: any, methodName: string) =>
    nestedCall(context, component, methodName, isComputedExist, callComputed, false)
